import Vue from 'vue'
import logger from 'util/logger'
import Badge from 'objects/badge/badge'

import withRender from './review-byline.html'
import './byline.scss'

const VALID_UGC_TYPES = [
  'r', // review,
  'rr' // review response
]

export default withRender(Vue.extend({
  data() { return { hasMenuItems: false } },
  props: {
    item: Object,
    showPurchaserBadge: Boolean,
    ugcType: {
      type: String,
      validator: value => VALID_UGC_TYPES.indexOf(value) > -1
    }
  },
  components: {
    'tt-badge': Badge
  },
  computed: {
    badges() {
      const badges = []
      if (this.item.isIndependent) {
        badges.push({ type: 'expert', label: this.$msg('badge.expert') })
      } else if (this.item.isStaff) {
        badges.push({ type: 'staff', label: this.$msg('badge.staff') })
      }
      if (this.item.expertLabel) {
        badges.push({ type: 'expert', label: this.item.expertLabel })
      }
      if (this.item.purchaseDateFormatted && this.showPurchaserBadge) {
        badges.push({ type: 'verified-purchaser', label: this.$msg('badge.verifiedPurchaser') })
      }
      return badges
    },
    dateCreatedFormatted() {
      return this.ugcType === 'rr' ? this.item.dateCreatedFormatted : ''
    },
    dateTime() {
      return this.item.dateCreatedMillis ? new Date(this.item.dateCreatedMillis).toISOString() :
        this.item.dateCreatedFormatted
    }
  },
  methods: {
    selectedAuthor() {
      // TODO...
      logger.debug('author selected...')
    }
  }
}))



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/objects/byline/review-byline.ts